import { create } from 'apisauce'
import { getBackendUrls } from '../../config/backendEnv'

const api = create({
  baseURL: getBackendUrls().endPoints1,
})

api.addResponseTransform(response => {
  if (!response.ok) throw response
})

export default api
